import * as yup from 'yup';
import { DateTime } from 'luxon';
import { CivilUnionVM } from 'mutation/view-models/civil-union';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';
import { idActRegex } from 'shell/constants/regex';
import { ActType } from 'shell/constants/act-type';
import { DocumentDigital } from 'shell/view-models/act-form';
// import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';

export const validationSchema = yup.object().shape({
  editDataControl: yup
    .object()
    .nullable()
    .shape({
      dateValidity: yup
        .date()
        .nullable()
        .required('campo obbligatorio')
        .typeError('Data non valida'),
    })
    .test(
      'editDataControl.dateValidity',
      'La data deve essere minore uguale del giorno corrente',
      (values) => {
        const castedValues = values as unknown as AccordionEditDataControl;

        if (castedValues.dateValidity && castedValues.dateValidity > DateTime.now()) {
          return new yup.ValidationError(
            'La data deve essere minore uguale del giorno corrente',
            undefined,
            'editDataControl.dateValidity'
          );
        }

        return true;
      }
    ),
  civilUnion: yup
    .object()
    .nullable()
    .shape({
      dateEvent: yup.date().nullable().required('Campo obbligatorio').typeError('Data non valida'),
      disabled: yup.boolean().nullable().notRequired(),
      searchPerson: yup.object().nullable().shape({
        fiscalCode: yup.string().nullable(),
      }),
      person: yup.object().nullable().shape({
        surname: yup.string().nullable(),
        name: yup.string().nullable(),
        withoutName: yup.boolean().nullable(),
        withoutSurname: yup.boolean().nullable(),
      }),
      isForeign: yup.boolean().nullable().notRequired(),
      italian: yup
        .object()
        .nullable()
        .shape({
          municipality: yup.object().nullable().shape({}),
          // .when('isForeign', {
          //   is: false || undefined,
          //   then: yup.object().nullable().shape({}).required('Campo obbligatorio'),
          //   otherwise: yup.object().nullable(),
          // }),
        }),
      foreign: yup
        .object()
        .nullable()
        .shape({
          foreignState: yup.object().nullable().shape({}),
          // .when('isForeign', {
          //   is: false || undefined,
          //   then: yup.object().nullable(),
          //   otherwise: yup.object().nullable().shape({}).required('Campo obbligatorio'),
          // }),
        }),
      exceptionalPlace: yup.string().nullable(),
      actType: yup.string(),
      digital: yup
        .object()
        .nullable()
        .when('actType', {
          is: ActType.AttoDigitale,
          otherwise: yup.object().nullable(),
          then: yup
            .object()
            .nullable()
            .shape({
              idAnsc: yup
                .string()
                .nullable()
                .matches(idActRegex, 'Formato non corretto')
                .test((value) => {
                  if (value) {
                    const [year] = value.split('-');
                    const isValid = year ? Number.parseInt(year) >= 2022 : true;

                    return isValid
                      ? true
                      : new yup.ValidationError(
                          "L'idAnsc deve avere anno maggiore al 2022",
                          undefined,
                          'civilUnion.digital.idAnsc'
                        );
                  }
                  return true;
                })
                .required('Campo richiesto'),
              documentDate: yup.date().nullable().notRequired().typeError('Formato non valido'),
              municipality: yup.object().shape({}).nullable().required('Campo richiesto'),
            })
            .test((values) => {
              const castedValues = values as unknown as DocumentDigital;

              if (
                castedValues?.municipality?.id &&
                castedValues?.istatCode &&
                castedValues?.municipality?.id === castedValues.istatCode
              ) {
                return true;
              }
              return new yup.ValidationError([
                new yup.ValidationError(
                  'Non coincidono i due codici ISTAT',
                  undefined,
                  'civilUnion.digital.municipality'
                ),
                new yup.ValidationError(
                  'Non coincidono i due codici ISTAT',
                  undefined,
                  'civilUnion.digital.istatCode'
                ),
              ]);
            }),
        }),
      paper: yup
        .object()
        .nullable()
        .when('actType', {
          is: ActType.AttoCartaceo,
          otherwise: yup.object().nullable(),
          then: yup.object().shape({
            actDate: yup
              .date()
              .nullable()
              .max(
                DateTime.local().plus({ days: 1 }),
                'La data non può essere successiva alla data odierna'
              )
              .typeError('Data non valida'),
            transcribed: yup.string().nullable(),
            actMunicipality: yup.object().nullable().shape({}).required('Il campo è richiesto'),
            actYear: yup
              .number()
              .nullable()
              .required('Campo richiesto')
              .typeError('Sono ammesse solamente cifre'),
            actNumber: yup
              .number()
              .nullable()
              .required('Campo richiesto')
              .typeError('Sono ammesse solamente cifre'),
            actPart: yup
              .string()
              .nullable()
              .required('Campo richiesto')
              .test(
                'part-ammisible-values',
                'Gli unici valori ammessi sono 1 o 2',
                (value) => ['1', '2'].indexOf(value || '') >= 0
              ),
            actSeries: yup.string().nullable(),
            actVolume: yup
              .string()
              .nullable()
              .when('actMunicipality.description', {
                is: (description: string) => (description || '').toLocaleLowerCase() === 'milano',
                then: yup
                  .string()
                  // .required('Campo obbligatorio')
                  .matches(/^R[0-9]{2}$/, {
                    message:
                      'Per il comune di Milano il volume è formato da R e due cifre(es. R00)',
                  }),
              }),
          }),
        }),
      generality: yup
        .object()
        .nullable()
        .shape({
          gender: yup.string().nullable(),
          birthDate: yup.date().nullable().typeError('Data non valida'),
        }),
    })
    // controlli cittadinanza
    .test('civilUnion.italian.municipality.description', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as CivilUnionVM;

      if (
        !castedValues.disabled &&
        !castedValues.isForeign &&
        !castedValues.italian?.municipality?.description &&
        !castedValues.foreign?.foreignState?.value &&
        !castedValues.exceptionalPlace
      ) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'civilUnion.italian.municipality.description'
        );
      }

      return true;
    })
    .test('civilUnion.foreign.foreignState.value', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as CivilUnionVM;

      if (
        !castedValues.disabled &&
        castedValues.isForeign &&
        !castedValues.italian?.municipality?.description &&
        !castedValues.foreign?.foreignState?.value &&
        !castedValues.exceptionalPlace
      ) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'civilUnion.foreign.foreignState.value'
        );
      }

      return true;
    })
    .test('civilUnion.exceptionalPlace', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as CivilUnionVM;

      if (
        !castedValues.disabled &&
        !castedValues.italian?.municipality?.description &&
        !castedValues.foreign?.foreignState?.value &&
        !castedValues.exceptionalPlace
      ) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'civilUnion.exceptionalPlace'
        );
      }

      return true;
    })
    // controllo ricerca persona
    .test('civilUnion.searchPerson.fiscalCode', 'Campo obbligatorio per la ricerca', (values) => {
      const castedValues = values as unknown as CivilUnionVM;

      if (
        castedValues.disabled &&
        !castedValues.person?.fiscalCode &&
        !castedValues.searchPerson?.fiscalCode
      ) {
        return new yup.ValidationError(
          'Campo obbligatorio per la ricerca',
          undefined,
          'civilUnion.searchPerson.fiscalCode'
        );
      }

      return true;
    })
    // controlli persona
    .test('civilUnion.person.surname', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as CivilUnionVM;

      if (
        !castedValues.disabled &&
        !castedValues.person?.surname &&
        !castedValues.person?.withoutSurname
      ) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'civilUnion.person.surname'
        );
      }

      return true;
    })
    .test('civilUnion.person.name', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as CivilUnionVM;

      if (
        !castedValues.disabled &&
        !castedValues.person?.name &&
        !castedValues.person?.withoutName
      ) {
        return new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.person.name');
      }

      return true;
    })
    // controlli generalità
    .test('civilUnion.generality.gender', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as CivilUnionVM;

      if (!castedValues.disabled && !castedValues.generality?.gender) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'civilUnion.generality.gender'
        );
      }

      return true;
    })
    .test('civilUnion.generality.birthDate', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as CivilUnionVM;

      if (!castedValues.disabled && !castedValues.generality?.birthDate) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'civilUnion.generality.birthDate'
        );
      }

      return true;
    }),
});
